module.exports = __webpack_public_path__ + "img/mobilebanner2.2ac64198.png";